import styled from 'styled-components';

const HierarchyCreateStyles = styled.div``;

export default HierarchyCreateStyles;
